import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from 'auth/FirebaseAuth';
import FirebaseService from "services/FirebaseService";
import { identifyUser, trackSessionStart, trackSessionEnd } from "services/UsageTrackingService";

const UserProfilesContext = createContext();
// const allViews = ['home', 'ccu', 'revenue', 'new-players-revenue', 'gateway-info', 'crm', 'item-amount', 'performance', 'urlshorter-metrics', 'royalarena-reports', 'activeplayers-per-country', 'sunset-followup', 'generate-player-purchase-report', 'upload-banner', 'modify-home-buttons', 'manage-patch', 'schedule-downtime', 'clone-accounts', 'find-player', 'find-guild', 'rank-players', 'twitch-users', 'send-items', 'ban-players', 'gm-tools', 'gold-count', 'accounts-np', 'global-bot', 'editor-info-json', 'all-emails', 'action-logs', 'log-analyzer', 'item-tracking', 'manage-rds', 'manage-users'];

export const UserProfilesProvider = ({ children }) => {
    const [userPerms, setUserPerms] = useState([]);
    const [userViews, setUserViews] = useState([]);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            console.log('User logged in');

            if (user) {
                // Track A: início de sessão + identificação no Clarity
                trackSessionStart(user.email);

                FirebaseService.getSelfPermissionsAndViews().then(([perms, views]) => {
                    setUserPerms([...perms]);
                    setUserViews([...views]);

                    // Telemetria desacoplada do caminho crítico de RBAC.
                    FirebaseService.getSelfRoleNames().then((roleNames) => {
                        identifyUser(user.email, roleNames, views?.length || 0, perms?.length || 0);
                    });
                });
            } else {
                // Track A: fim de sessão no logout (no-op se não houver sessão ativa)
                trackSessionEnd();
            }
        })

        return () => unsubscribe();
    }, []);

    return (
        <UserProfilesContext.Provider value={{ userPerms, userViews, setUserViews }}>
            {children}
        </UserProfilesContext.Provider>
    )
}

export const useUserProfiles = () => useContext(UserProfilesContext)
